"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitButton = exports.ConfirmationMessage = exports.ErrorMessage = exports.FeedbackForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Yup = __importStar(require("yup"));
var fields_1 = require("./fields");
var feedback_context_1 = require("./feedback-context");
var formik_1 = require("formik");
var solid_1 = require("@heroicons/react/solid");
var outline_1 = require("@heroicons/react/outline");
var spinner_1 = __importDefault(require("./spinner"));
var use_feedback_widget_1 = require("./use-feedback-widget");
var FeedbackValidationSchema = Yup.object().shape({
    text: Yup.string().required('Feedback field is required'),
});
var FeedbackForm = function (_a) {
    var location = _a.location;
    var _b = (0, use_feedback_widget_1.useFeedbackWidget)({ location: location }), initialValues = _b.initialValues, submitFeedbackForm = _b.submitFeedbackForm, isSubmitted = _b.isSubmitted, error = _b.error;
    return ((0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: initialValues, validationSchema: FeedbackValidationSchema, onSubmit: submitFeedbackForm, children: function (_a) {
            var errors = _a.errors, touched = _a.touched, isSubmitting = _a.isSubmitting;
            return ((0, jsx_runtime_1.jsxs)(formik_1.Form, { "data-sr-feeback-widget-form": "", placeholder: "", children: [(0, jsx_runtime_1.jsx)(fields_1.FeedbackField, { errors: errors, touched: touched, isSubmitted: isSubmitted }), (0, jsx_runtime_1.jsxs)("div", { "data-sr-feedback-widget-radio-group-container": "", children: [(0, jsx_runtime_1.jsx)(fields_1.EmotionField, { name: "context.emotion", id: "context.emotion" }), (0, jsx_runtime_1.jsx)(fields_1.CategoryField, { name: "context.category", id: "context.category" })] }), (0, jsx_runtime_1.jsx)(exports.SubmitButton, { isSubmitting: isSubmitting, children: "Send feedback" }), isSubmitted && (0, jsx_runtime_1.jsx)(exports.ConfirmationMessage, {}), error && (0, jsx_runtime_1.jsx)(exports.ErrorMessage, { children: error })] }));
        } }));
};
exports.FeedbackForm = FeedbackForm;
var ErrorMessage = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsxs)("div", { "aria-live": "polite", className: "flex items-center justify-center rounded-md bg-pink-300/10 px-5 py-3 font-medium leading-tight text-pink-300", children: [(0, jsx_runtime_1.jsx)(outline_1.XCircleIcon, { className: "mr-2 h-6 w-6", "aria-hidden": "true" }), " Error:", ' ', children] }));
};
exports.ErrorMessage = ErrorMessage;
var ConfirmationMessage = function (_a) {
    var _b = _a.message, message = _b === void 0 ? "Feedback sent, thank you!" : _b, _c = _a.isModal, isModal = _c === void 0 ? true : _c;
    var setIsFeedbackDialogOpen = (0, feedback_context_1.useFeedback)().setIsFeedbackDialogOpen;
    return ((0, jsx_runtime_1.jsxs)("div", { "aria-live": "polite", className: "flex flex-wrap items-center justify-center rounded-md bg-teal-300/20 px-5 py-4 text-center text-sm font-semibold text-teal-300", children: [(0, jsx_runtime_1.jsx)(solid_1.CheckIcon, { className: "mr-1 h-4 w-4", "aria-hidden": "true" }), ' ', (0, jsx_runtime_1.jsx)("span", { children: message }), isModal && ((0, jsx_runtime_1.jsx)("button", { className: "inline-block pl-2 underline", onClick: function () {
                    setIsFeedbackDialogOpen(false);
                }, children: "Close" }))] }));
};
exports.ConfirmationMessage = ConfirmationMessage;
var SubmitButton = function (_a) {
    var isSubmitting = _a.isSubmitting, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("button", { type: "submit", disabled: isSubmitting, "data-sr-feedback-widget-submit": "", children: isSubmitting ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(spinner_1.default, { className: "mr-1 w-4", "aria-hidden": "true" }), " Sending..."] })) : (children) }));
};
exports.SubmitButton = SubmitButton;
exports.default = exports.FeedbackForm;
